import { computed as c, ref as g, readonly as f } from "vue";
let l = {};
const d = c(() => window.navigator.language), t = g(window.navigator.language.substring(0, 2));
let o;
const v = () => Object.keys(l).find((n) => n === o), b = (n, e, a) => {
  o = a && v() ? a : "en", t.value = e || t.value, l = n;
}, p = (n, e) => {
  let a = l[t.value];
  const s = l[o];
  if (a || (a = s), !a)
    return `!${n}!`;
  let r = a[n] || s[n];
  return r ? (e && e.forEach((u, i) => {
    r = r.replace(`{${i}}`, u);
  }), r) : `!${n}!`;
}, T = (n) => {
  t.value = n;
}, $ = () => ({
  translate: p,
  locale: d,
  setLanguage: T,
  language: f(t)
});
export {
  b as configureTranslations,
  $ as useTranslator
};
